interface AnimatedPlaceholderProps {
  text: string;
  isTyping: boolean;
}

export default function AnimatedPlaceholder({ text, isTyping }: AnimatedPlaceholderProps) {
  return (
    <span className="animated-placeholder">
      {text}
      <span className={`animated-placeholder__cursor ${isTyping ? 'animated-placeholder__cursor--typing' : ''}`}>
        |
      </span>
    </span>
  );
}
